import { render, staticRenderFns } from "./inventoryManagement.vue?vue&type=template&id=09ccff99&scoped=true&"
import script from "./inventoryManagement.vue?vue&type=script&lang=ts&"
export * from "./inventoryManagement.vue?vue&type=script&lang=ts&"
import style0 from "./inventoryManagement.vue?vue&type=style&index=0&id=09ccff99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ccff99",
  null
  
)

export default component.exports